import Text from "@/components/Text";

export interface PayersCountProps {
  totalCount: number;
  filteredCount: number;
  isFiltered: boolean;
}

const PayersCount = ({
  totalCount,
  filteredCount,
  isFiltered,
}: PayersCountProps) => (
  <Text fontWeight={600} role="status" aria-live="polite">
    {isFiltered
      ? `Showing ${filteredCount} of ${totalCount}`
      : `Total Payers: ${totalCount}`}
  </Text>
);

export default PayersCount;
